import { toFirstUpperCase, generateRandomString } from '@gp/utils/common';
import { STAKEHOLDER_MODULE_KEY_MAPPING } from './consts';

export const getFullOwnerName = (organization: string, shortOwnerName: string): string => {
  let result = toFirstUpperCase(shortOwnerName);
  if (['development', 'publishing'].includes(shortOwnerName)) {
    const suffixMap: any = {
      iegg: 'Project Owner',
      studio: 'Leadership Team',
    };
    const suffix = suffixMap[organization] || 'Project Owner';
    result = `${result} ${suffix}`;
  }
  return result;
};

const MOCK_USER_ID_PREFIX = 'mock';

/**
 * 获取iegg的人员id
 * 由于历史需求历史数据原因，存在部分iegg的人员只有name，没有id，导致编辑时，人员下拉筛选器默认没展示人员信息
 * 所以通过这个方法处理iegg的人员id
 * 本身存在id的直接返回id
 * 不存在id的 则临时生成一个模拟id，解决编辑时，人员下拉筛选器没有展示人员信息问题
 * 注意在编辑提交时，需要删除前端生成的模拟id
 * @param id iegg的人员id
 * @param name iegg的人员name
 * @returns 处理后的iegg的人员id
 */
export const getMockUserIdOfIEGG = (id?: string, name?: string): string => {
  if (id) return id;
  if (!id && !name) return '';
  const randomStr = generateRandomString();
  return `${MOCK_USER_ID_PREFIX}-${name}-${randomStr}`;
};

/**
 * 判断指定id是否为前端生成的模拟id
 * @param id iegg的人员id
 * @returns 是否为前端生成的模拟id
 */
export const isMockUserIdOfIEGG = (id?: string): boolean => {
  if (!id) return false;
  return id?.startsWith(`${MOCK_USER_ID_PREFIX}-`) || false;
};

/**
 * 处理owner列表中owner的user_id
 * user_id为真实id的不处理
 * user_id为前端临时生成的mockid时，需要删除为空字符串
 * @param list owner列表
 * @returns owner列表
 */
export const deleteMockUserIdOfIEGG = (list?: IOwnerList[] | null): IOwnerList[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const { user_id: userId = '' } = item || {};
    const isMockUserId = isMockUserIdOfIEGG(userId);
    return { ...item, user_id: isMockUserId ? '' : userId };
  });
};

export const scroll2Module = (rootNode?: HTMLElement | null, moduleKey?: string) => {
  if (!rootNode) return;
  switch (moduleKey) {
    // REMARK: IEGG模块暂时不需要滚动
    case STAKEHOLDER_MODULE_KEY_MAPPING.IEGG: {
      break;
    }
    case STAKEHOLDER_MODULE_KEY_MAPPING.STUDIO: {
      rootNode
        .querySelector('.dbg-pipeline-project-detail-stakeholder-org__studio')
        ?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
};
